// Lets code outside Index.tsx's component tree (e.g. App.tsx's idle-timeout handler)
// know the current UserSession id, so it can mark LogoutAt without needing React context.
let _sessionId: number | null = null

export function setActiveSessionId(id: number | null) {
  _sessionId = id
}

export function getActiveSessionId(): number | null {
  return _sessionId
}
